import { useState, useEffect } from "react";
import data from "./hiringOpportunities.json";
import "./hiringOpportunities.scss";
import ReactCarousel from "../../Common/Carousel/carousel";
import PopUp from "../../Common/Popup/popUp";
import iconPathURL from "../../Common/iconPath";
const iconPathBaseUrl = process.env.PUBLIC_URL + "/assets/icons/";

export default function HiringOppurtunities() {
  const [showModelPopUp, setShowModelPopUp] = useState(true);
  const hiringData = data.data;

  useEffect(() => {}, []);
  return (
    <div className="hiring-container">
      {showModelPopUp && (
        <PopUp toggleShowPopup={() => setShowModelPopUp(false)} />
      )}
      <div className="banner-parent-conetnt">
        <img
          src={iconPathURL("hiring/hiring_header.png")}
          className="banner-image"
          alt="img"
        />

        <div className="banner-content">
          <h1 className="banner-title">
            Explore limitless possibilities at MBRDI
          </h1>
          <p className="banner-text">
            Be the mind behind the world’s best cars, bringing luxury and style
            with future-next technology
          </p>
        </div>
      </div>

      <section className="text-container-section col-xs-12 col-sm-12 col-md-8 col-lg-10">
        <p>{hiringData.p1}</p>
        <p>{hiringData.p2}</p>
        <p>{hiringData.p3}</p>
      </section>
      <img
        className="img-content"
        src={iconPathURL("hiring/hiring_content.png")}
        alt="img"
      ></img>
      <ReactCarousel autoPlay={5000} infiniteLoop={true} showStatus={false}>
        <div className="img-carousel">
          <a
            target="new"
            href="https://www.techgig.com/challenge/mercedes-benz-hiring-test/"
          >
            <img
              className="hiring-img"
              src={iconPathURL("hiring/hiring_4.png")}
              alt="img"
            ></img>
          </a>
        </div>
        <div className="img-carousel">
          <a
            target="new"
            href="https://assessment.hackerearth.com/challenges/new/hiring/mercedes-benz-cloud-platform-developer-hiring-challenge-v5/"
          >
            <img
              className="hiring-img"
              src={iconPathURL("hiring/hiring_1.png")}
              alt="img"
            ></img>
          </a>
        </div>
        <div className="img-carousel">
          <a
            target="new"
            href="https://assessment.hackerearth.com/challenges/new/hiring/mercedes-benz-cloud-platform-developer-hiring-challenge-v5/"
          >
            <img
              className="hiring-img"
              src={iconPathURL("hiring/hiring_2.png")}
              alt="img"
            ></img>
          </a>
        </div>
        <div className="img-carousel">
          <a
            target="new"
            href="https://assessment.hackerearth.com/challenges/new/hiring/mercedes-benz-cloud-platform-developer-hiring-challenge-v5/"
          >
            <img
              className="hiring-img"
              src={iconPathURL("hiring/hiring_3.png")}
              alt="img"
            ></img>
          </a>
        </div>
      </ReactCarousel>
    </div>
  );
}
